<script>
  import tiposDocumento from '../../tipos-documento';
  import ListaDespesas from './FormListaDespesas.vue';
  import { datepicker, checkbox } from 'vue-strap';
  import radio from '~componentes/Radio.vue';
  import projetoServico from '~modulos/projeto/servico';
  
  export default {
    components: { datepicker, checkbox, ListaDespesas, radio },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        despesa: this.camposDespesa(),
        tiposDocumento: tiposDocumento,
        manterObservacao: false,
        tipoDocumento: 'cpf',
        usuario: this.$storage.usuario(),
        desabilitaCampo: false,
        metaEtapas: [],
        rubricas: [],
        subrubricas: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      camposDespesa() {
        return {
          cpfCnpj: '',
          nome: '',
          valor: '',
          tipoDocumento: '',
          nota: '',
          data: '',
          devolucoesDiversas: false,
          observacao: '',
          idRubrica: '',
          idSubrubrica: '',
          idProjetoMetaEtapa: '',
          projetoMetaEtapa: {
            idProjetoMetaEtapa: '',
            meta: {
              nome: ''
            },
            etapa: {
              nome: ''
            },
          },
          rubrica: {
            id: null,
            nome: '',
          },
          subrubrica: {
            id: null,
            nome: '',
          }
        }
      },
      listaDeMetaEtapas(idProjeto) {
        this.despesa.idProjetoMetaEtapa = '';
        this.despesa.idRubrica = '';
        this.despesa.idSubrubrica = '';
        this.rubricas = [];
        this.subrubricas = [];

        if (this.solicitacao.idProjeto === null) {
          return;
        }

        projetoServico
          .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas(idProjeto) {
        this.despesa.idRubrica = '';
        this.despesa.idSubrubrica = '';
        this.subrubricas = [];

        if (this.solicitacao.projeto.utilizarMetaEtapaProjeto) {
          return projetoServico
            .rubricas(idProjeto, this.despesa.idProjetoMetaEtapa)
            .then(rubricas => {
              this.rubricas = rubricas;
            });
        }
        else {
          return projetoServico
            .rubricas(idProjeto)
            .then(rubricas => {
              this.rubricas = rubricas;
            });
        }
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.projeto.idProjeto || idProjeto;
        idRubrica = this.despesa.idRubrica || idRubrica;

        this.despesa.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        if (this.solicitacao.projeto.utilizarMetaEtapaProjeto) {
          return projetoServico
            .subrubricas(idProjeto, idRubrica, this.despesa.idProjetoMetaEtapa)
            .then(subrubricas => {
              this.subrubricas = subrubricas;
            });
        }
        else {
          return projetoServico
            .subrubricas(idProjeto, idRubrica)
            .then(subrubricas => {
              this.subrubricas = subrubricas;
            });
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              if (this.validarCompraDireta())
                this.adicionar();
            }
          })
      },
      validarCompraDireta() {
        if (!this.solicitacao.compraDireta)
          return true;

        var valorLimiteCompraDireta = 0;
        var valorSolicitacao = 0;

        if (this.solicitacao.projeto.valorLimiteCompraDireta)
          valorLimiteCompraDireta = this.$options.filters.formatarNumero(this.solicitacao.projeto.valorLimiteCompraDireta, true);

        if (this.despesa.valor)
          valorSolicitacao = this.$options.filters.formatarNumero(this.despesa.valor, true);

        if ((valorSolicitacao - valorLimiteCompraDireta) <= 0) return true;

        this.$swal(
          '',
          'O valor da solicitação de compra direta está limitado a um valor de até ' + `R$ ${this.$options.filters.formatarNumero(valorLimiteCompraDireta)}`,
          'info'
        );

        throw new Error("validacao");
        return false;
      },
      adicionar() {
        const copiaDespesa = Object.assign(this.despesa);

        copiaDespesa.projetoMetaEtapa = this.projetoMetaEtapaSelecionado(copiaDespesa.idProjetoMetaEtapa);
        copiaDespesa.rubrica = this.rubricaSelecionada(copiaDespesa.idRubrica);
        copiaDespesa.subrubrica = this.subrubricaSelecionada(copiaDespesa.idSubrubrica);

        this.solicitacao.despesas.push(copiaDespesa);

        this.despesa = this.camposDespesa();

        if (this.manterObservacao) {
          this.$set(this.despesa, 'observacao', copiaDespesa.observacao)
        }

        this.$validator.reset();
        this.desabilitarCompraDireta();
        // $('#tabs a[href="#tab-itens-solicitacao"]').tab('show');
      },
      checkCompraDireta() {
        this.habilitarCampo();

        if (!this.solicitacao.compraDireta)
          this.desabilitarCampo();
      },
      desabilitarCompraDireta(sol) {
        if (!sol)
          sol = this.solicitacao;

        this.habilitarCampo();

        if (sol.compraDireta)
          this.desabilitarCampo(sol);
      },
      desabilitarCampo(sol) {
        if (sol.despesas.length < 1)
          return;

        this.desabilitaCampo = true;
        $('#cpf-cnpj').attr('disabled', 'disabled');
        $('#nome').attr('disabled', 'disabled');
        $('#valor').attr('disabled', 'disabled');
        $('#tipo-documento').attr('disabled', 'disabled');
        $('#nota').attr('disabled', 'disabled');
        $('#data input').attr('disabled', 'disabled');
        $('#observacao').attr('disabled', 'disabled');
        $('#adicionardespesa').attr('disabled', 'disabled');
        $('#meta-etapa').attr('disabled', 'disabled');
        $('#rubrica').attr('disabled', 'disabled');
        $('#subrubrica').attr('disabled', 'disabled');
      },
      habilitarCampo() {
        this.desabilitaCampo = false;
        $('#cpf-cnpj').removeAttr('disabled');
        $('#nome').removeAttr('disabled');
        $('#valor').removeAttr('disabled');
        $('#tipo-documento').removeAttr('disabled');
        $('#nota').removeAttr('disabled');
        $('#data input').removeAttr('disabled');
        $('#observacao').removeAttr('disabled');
        $('#adicionardespesa').removeAttr('disabled');
        $('#meta-etapa').removeAttr('disabled');
        $('#rubrica').removeAttr('disabled');
        $('#subrubrica').removeAttr('disabled');
      },
      limparDocumento() {
        this.despesa.cpfCnpj = '';
      },
      projetoMetaEtapaSelecionado(idProjetoMetaEtapa) {
        return this.metaEtapas.find(metaEtapa => metaEtapa.idProjetoMetaEtapa == idProjetoMetaEtapa);
      },
      rubricaSelecionada(idRubrica) {
        return this.rubricas.find(rubrica => rubrica.id == idRubrica);
      },
      subrubricaSelecionada(idSubrubrica) {
        return this.subrubricas.find(subrubrica => subrubrica.id == idSubrubrica);
      },
    },
    mounted() {
      //$('.datepicker input').attr('readonly', '');
      this.$events.on('desabilitarCompraDireta', this.desabilitarCompraDireta);
    },
    computed: {
      exibirRubricaSubrubricaSolicitacaoWeb() {
        return this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.solicitacao.projeto.utilizarRubricaSubrubricaWeb;
      }
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
      'solicitacao.idProjeto': 'listaDeMetaEtapas',
    }
  }
</script>

<template>
  <div>

    <div class="row" v-if="usuario.permissoes.solCompraDireta && solicitacao.projeto.permiteUtilizarCompraDireta">
      <div class="col-lg-12">
        <checkbox style="float: right;" v-model="solicitacao.compraDireta" :true-value="true" type="success" @checked="checkCompraDireta">
          <small>Este pagamento é uma compra direta</small>
        </checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('cpfCnpj')}">
          <!--<label class="control-label" for="cpf-cnpj">CPF/CNPJ</label>-->

          <label class="control-label radios" for="cpf-cnpj" style="margin-bottom: 3px">
            <radio style="margin-right: 10px"
                   v-model="tipoDocumento"
                   :disabled="desabilitaCampo"
                   selected-value="cpf"
                   :inline="true"
                   class="no-margin-bottom no-margin-top"
                   type="success">
              CPF
            </radio>
            <radio v-model="tipoDocumento"
                   :disabled="desabilitaCampo"
                   selected-value="cnpj"
                   :inline="true"
                   class="no-margin-bottom no-margin-top"
                   type="success">
              CNPJ
            </radio>
          </label>

          <input type="text"
                 class="form-control"
                 id="cpf-cnpj"
                 v-model="despesa.cpfCnpj"
                 data-vv-name="cpfCnpj"
                 data-vv-as="CPF/CNPJ"
                 maxlength="18"
                 v-mascara="tipoDocumento"
                 v-validate="`required|${tipoDocumento === 'cnpj' ? 'cnpj' : 'cpf'}`">

          <p class="text-danger" v-show="errors.has('cpfCnpj')">{{ errors.first('cpfCnpj') }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">Nome/Razão Social</label>

          <input type="text"
                 class="form-control"
                 id="nome"
                 v-model="despesa.nome"
                 maxlength="100"
                 data-vv-name="nome"
                 data-vv-as="Nome/Razão Social"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor">Valor</label>

          <input type="text"
                 class="form-control text-right"
                 id="valor"
                 v-model="despesa.valor"
                 data-vv-name="valor"
                 data-vv-as="Valor"
                 v-validate="'required'"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('tipoDocumento')}">
          <label class="control-label" for="tipo-documento">Tipo de documento</label>

          <select id="tipo-documento"
                  class="form-control"
                  v-model="despesa.tipoDocumento"
                  data-vv-name="tipoDocumento"
                  data-vv-as="Tipo de documento"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option v-for="tipoDocumento in tiposDocumento" :value="tipoDocumento">{{ tipoDocumento }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoDocumento')">{{ errors.first('tipoDocumento') }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('nota')}">
          <label class="control-label" for="nota">Nº do Documento/Nota</label>

          <input type="text"
                 class="form-control"
                 id="nota"
                 v-model="despesa.nota"
                 maxlength="30"
                 data-vv-name="nota"
                 data-vv-as="Nº do Documento/Nota"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nota')">{{ errors.first('nota') }}</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group required" :class="{'has-error': errors.has('data')}">
          <label class="control-label" for="data">Data</label>

          <datepicker id="data"
                      v-mascara="'data-mask'"
                      v-model="despesa.data"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="data"
                      data-vv-as="Data"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('data')">{{ errors.first('data') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="solicitacao.projeto.utilizarMetaEtapaProjeto && exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
          <label class="control-label" for="meta-etapa">Meta etapa</label>

          <select class="form-control"
                  id="meta-etapa"
                  v-model="despesa.idProjetoMetaEtapa"
                  data-vv-name="metaEtapa"
                  data-vv-as="meta etapa"
                  v-validate="'required'"
                  @change="listaDeRubricas(solicitacao.projeto.idProjeto)">
            <option value="">Selecione...</option>
            <option :value="metaEtapa.idProjetoMetaEtapa"
                    v-for="(metaEtapa, index) in metaEtapas">
              {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select class="form-control"
                  id="rubrica"
                  v-model="despesa.idRubrica"
                  data-vv-name="rubrica"
                  data-vv-as="rubrica"
                  v-validate="'required'"
                  @change="listaDeSubrubricas">
            <option value="">Selecione...</option>
            <option :value="rubrica.id"
                    v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select class="form-control"
                  id="subrubrica"
                  v-model="despesa.idSubrubrica"
                  data-vv-name="subrubrica"
                  data-vv-as="subrubrica"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="subrubrica.id"
                    v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <div class="checkbox">
            <checkbox v-model="despesa.devolucoesDiversas" value="1" type="primary" id="devolucoesdiversas" :disabled="desabilitaCampo">
              Devoluções diversas
            </checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <div class="checkbox">
            <checkbox v-model="manterObservacao" value="1" type="primary" id="manterObservacao" :disabled="desabilitaCampo">
              Manter observação (caso esta solicitação demandar outras despesas com a mesma observação)
            </checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="observacao">Observação</label>

          <input type="text"
                 class="form-control"
                 id="observacao"
                 v-model="despesa.observacao"
                 maxlength="200">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar" id="adicionardespesa">
            <i class="fa fa-plus"></i>
            Adicionar despesa
          </button>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">

    <lista-despesas 
                    :despesas="solicitacao.despesas"
                    :utilizarMetaEtapaProjeto="solicitacao.projeto.utilizarMetaEtapaProjeto"
                    :exibirRubricaSubrubricaSolicitacaoWeb="exibirRubricaSubrubricaSolicitacaoWeb">
    </lista-despesas>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-terceiro/componentes/compartilhado/FormDespesas.vue